import { Close } from '@mui/icons-material';
import { Autocomplete, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, IconButton, MenuItem, Radio, RadioGroup, Select, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react'
import ChefForPartyService from '../../services/ChefForPartyService';
import EventBus from '../../EventBus';
import { EventBusEventsEnum } from '../../enums/EventBusEventsEnum';
import { CustomSnackbarTypes } from './CustomSnackBar';
import { useNavigate } from "react-router-dom";
import { useRefresh } from 'react-admin';
import { IngredientsCategoryEnum } from '../../enums/IngredientCategoryEnum';


let chefForPartyService = new ChefForPartyService();
function AddIngredientDialog(props: any) {
    let { data, open, callback, type } = props;
    const[ingredients, setIngredients] = useState<any>([]);
    const [ingredient, setIngredient] = useState<any>(null);
    const [customName, setCustomName] = useState<string>('');
    const [ingredientType, setIngredientType] = useState<string>("normal");
    const [quantityType, setQuantityType] = useState<string>("g");
    const [category, setCategory] = useState<string>(IngredientsCategoryEnum.VEGETABLES_FRUITS);
    const [quantity, setQuantity] = useState<string>("");
    const navigate = useNavigate();
    const refresh = useRefresh();



    function fetchIngredients() {
        chefForPartyService.getAllIngredientsForParty(1000, 0, {}, {}).then((response: any) => {
            if (response && response.data) {
                setIngredients(response.data);
            }
        }).catch((error: any) => {
            console.error("Error fetching ingredients:", error);
        });
    }

    useEffect(()=>{
        if(ingredient){
            setCategory(ingredient?.category);
            setQuantityType(ingredient?.unit);
        }
    },[ingredient])

    function addIngredient() {
        if (ingredientType === 'normal' && ingredient && quantity && quantityType && !type) {
            let payload = {
                ingredientId: ingredient?.id,
                ingredientName: ingredient?.title,
                quantityEdited: quantity,
                unit: quantityType,
                category: category
            };
            chefForPartyService.addIngredientToParty(data?.id, payload).then((response: any) => {
                EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                    message: "Added successfully",
                    type: CustomSnackbarTypes.SUCCESS,
                  });
                  navigate(`/ChefForParty/${data?.id}/show/4`)
                  callback(null);
                  refresh();
            }).catch((error: any) => {
                console.error("Error adding ingredient:", error);
            });
        } else if (ingredientType === 'custom' && customName && quantity && quantityType && !type) {
            let payload = {
                ingredientName: customName,
                quantityEdited: quantity,
                unit: quantityType,
                category: category,
            };
            chefForPartyService.addIngredientToParty(data?.id, payload).then((response: any) => {
                EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                    message: "Added successfully",
                    type: CustomSnackbarTypes.SUCCESS,
                  });
                  navigate(`/ChefForParty/${data?.id}/show/4`)
                  callback(null);
                  refresh();
            }).catch((error: any) => {
                console.error("Error adding custom ingredient:", error);
            });
        }
        else if(type){
            let payload = {
                id: data?.id,
                ingredientId: data?.ingredient_id,
                ingredientName: data?.ingredient_name,
                quantityEdited: quantity,
                unit: data?.unit,
            };
            chefForPartyService.addIngredientToParty(data?.party_id, payload).then((response: any) => {
                EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                    message: "Added successfully",
                    type: CustomSnackbarTypes.SUCCESS,
                  });
                  navigate(`/ChefForParty/${data?.party_id}/show/4`)
                  callback(null);
                  refresh();
            }).catch((error: any) => {
                console.error("Error adding custom ingredient:", error);
            });
        }
        else {
            alert("Please select or enter an ingredient.");
        }
    }

    React.useEffect(() => {
        if (open && !type) {
            fetchIngredients();
        }
    }, [open, type]);

    function handleClose() {
        callback(null);
    }

  return (
    <>
     <Dialog
            onClose={handleClose}
            open={props.open}
            scroll={"paper"}
            maxWidth="sm"
            fullWidth
        >
                <DialogTitle>{type ? 'Update Ingredient' : 'Add Ingredient'}</DialogTitle>
                <DialogContent>
                    <IconButton onClick={() => props.callback(null)} sx={{ position: 'absolute', top: 2, right: 5 }}> <Close /> </IconButton>
                    <FormControl style={{width:'100%', marginBottom: "20px" }}>
                        {type && <Box>{`${data?.ingredient_name} ${data?.quantityEdited ? data?.quantityEdited : data?.quantity} ${data?.unit}`}</Box>}
                        {
                            !type && <FormControl>
                                <RadioGroup
                                    aria-labelledby="demo-controlled-radio-buttons-group"
                                    name="controlled-radio-buttons-group"
                                    value={ingredientType}
                                    onChange={(event)=> setIngredientType((event.target as HTMLInputElement).value)}
                                    row
                                >
                                    <FormControlLabel value="normal" control={<Radio />} label="NORMAL" />
                                    <FormControlLabel value="custom" control={<Radio />} label="CUSTOM" />
                                </RadioGroup>
                            </FormControl>
                        }
                        {
                            ingredients && ingredients.length > 0 && ingredientType === 'normal' && !type && (
                                <Autocomplete
                                    id="tags-standard"
                                    value={ingredient}
                                    options={ingredients?.map((ingredient: any) => {
                                    return { title: ingredient?.name, id: ingredient?.id , category: ingredient?.category, unit: ingredient?.unit};
                                    })}
                                    onChange={(e, v: any) => setIngredient(v)}
                                    getOptionLabel={(option: any) => option.title}
                                    renderInput={(params) => (
                                    <TextField {...params} variant="standard" label="Select Ingredient" placeholder="Enter Your Ingredient" />
                                    )}
                                />
                            )
                        }
                        {
                            ingredientType === 'custom' && !type && (
                                <TextField
                                    label="Custom Ingredient"
                                    variant="standard"
                                    value={customName}
                                    onChange={(e) => setCustomName(e.target.value)}
                                />
                            )
                        }
                        <TextField
                            label="Quantity"
                            variant="standard"
                            value={quantity}
                            onChange={(e) => setQuantity(e.target.value)}
                        />
                        {
                            !type && 
                            <Select
                                labelId="type"
                                id="type"
                                label="type"
                                value={quantityType}
                                sx={{marginTop:"2rem"}}
                                onChange={(event: any) => {
                                    setQuantityType(event.target.value);
                                }}
                            >
                                {['g', 'pieces', 'ml'].map((d: any) => (
                                    <MenuItem key={d} value={d}>
                                        {d}
                                    </MenuItem>
                                ))}
                            </Select>
                        }
                        {
                            !type && 
                            <Select
                                labelId="category"
                                id="category"
                                label="category"
                                value={category}
                                sx={{marginTop:"2rem"}}
                                onChange={(event: any) => {
                                    setCategory(event.target.value);
                                }}
                            >
                                {Object.values(IngredientsCategoryEnum).map((d: any) => (
                                    <MenuItem key={d} value={d}>
                                        {d}
                                    </MenuItem>
                                ))}
                            </Select>
                        }
                    </FormControl>
                </DialogContent>
                <DialogActions style={{ marginTop: "12px" }}>
                    <Button
                        variant="contained"
                        onClick={() => {
                            addIngredient();
                        }}
                        size={"large"}
                    >
                        Submit
                    </Button>
                    <Button
                        variant="contained"
                        color={"error"}
                        onClick={() => {props.callback(null)}}
                        size={"large"}
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
    </>
  )
}

export default AddIngredientDialog
